import { ITranslationItems } from '../../../utils/language';

export const sharedCopy: {
  cardWrappers: ITranslationItems;
} = {
  cardWrappers: {
    noArticles: {
      nl: 'Er zijn helaas geen artikelen beschikbaar over dit onderwerp.',
      en: 'Unfortunately, there are no articles available about this topic.',
    },
    overviewLinkLabel: {
      nl: 'Bekijk alle oplossingen',
      en: 'See all solutions',
    },
  },
};
